import './Vector.scss';

export const Vector: React.FC<{ vector: string }> = ({ vector }) => {
  return (
    <div className="vector-wraper" id="vector">
      <div style={{ backgroundImage: `url(${vector})` }} className={'vector '} />
    </div>
  );
};
